import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, LinearProgress, DialogActions, DialogContentText} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import QtTemplateQuesTypeSave from './QtTemplateQuesTypeSave';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const childRefSave = React.useRef();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [pageLoading, setPageLoading] = React.useState(true);
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  //const [saveLoading, setSaveLoading] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [privileges, setPrivileges] = React.useState("");
  const [questionType, setQuestionType] = React.useState("");
  const [dataObj, setDataObj] = React.useState({});

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    if(open){
      getApiData();
    }
    if(open && props.dataObj && props.dataObj.autoId){	
      setQuestionType(props.dataObj.questionTypeName);

    }else{
      setQuestionType("");

    }
	}, [props.dataObj,open]);

  async function getApiData(){
		///alert(userObj.token);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			
			axios.get(env.API_URL+"/exams/read/qt-template-question-types?templateId="+props.dataObj.autoId, axiosHeader) 
			   .then(response => {
				// alert("status >> "+response.status); 
			 	// alert("Just Checking >> "+JSON.stringify(response)); 
				 setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					///Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					///childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					setRows(response.data.obj.list);
					setPrivileges(response.data.obj.privileges);
				}		
			})
			// .catch((error) => {
			// 	alert("ERROR: ", error);
			// })	
	}

  function addNew(){ 
			setDataObj({});
			childRefSave.current.handleClickOpen();
	}
  function edit(obj){ 
			setDataObj(obj);
			childRefSave.current.handleClickOpen();
	}
  function del(obj){ 
    setDataObj(obj);
    setDeleteDialogShow(true);
  }

	function deleteData(){
		if(dataObj!=null && userObj.loginId && userObj.token){
      setDeleteDialogShow(false);

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'
				}
			}; 

		  const data = new FormData();
		  data.append('id', dataObj.autoId);
      data.append('templateId', dataObj.templateId);
				 
		  axios.post(env.API_URL+'/exams/delete/qt-template-question-types', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Question type has been deleted.");
			  	setRows(response.data.obj.list);
					return false;
				}else{
			  	setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Question type could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					console.log("ERROR: ", error);
				})	
		}		
	
		
	}

  function deleteDialogHide(){
		setDeleteDialogShow(false);
	}


  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-10px'}} className="btmbdrgry" onClose={handleClose}><h3>{props.dataObj.templateTitle}:- Question Types</h3></DialogTitle>        
        {pageLoading?<LinearProgress />:null}
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <th>Question Type</th>
                            <th>Question Type Label</th>
                            <th>Status</th>
                            <th>
                                <i onClick={()=>{addNew()}} title="Add New" className="fa fa-plus-circle" style={{fontSize:25, color:'#0158dc',cursor:'pointer'}} />  
                            </th>                            
                        </tr>
                        {(rows && rows.length>0)?rows.map((row,i)=>(
                        <tr key={'tr'+i} style={{backgroundColor:'#FFFFFF'}} >
                            <td>{row.questionTypeName}</td>
                            <td>{row.questionTypeLabel}</td>
                            <td>{row.status===1?<>Active</>:<>Inactive</>}</td> 
                            <th>
                                {(privileges && privileges.length>0 && privileges.indexOf("update")>-1)?<>
                                  <i onClick={()=>{edit(row)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:15, color:'#0158dc',marginRight:15, cursor:'pointer'}} />
                                </>:null}
                                {(privileges && privileges.length>0 && privileges.indexOf("delete")>-1)?
                                  <i onClick={()=>{del(row)}} title="Delete" className="fa fa-trash" style={{fontSize:15, color:'#0158dc', cursor:'pointer'}} />
                                :null}
                            </th>                           
                        </tr>
                        )):<>No Question Types Found</>}
                      </table>


                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <QtTemplateQuesTypeSave dataObj={dataObj} templateObj={props.dataObj} setRows={setRows} ref={childRefSave} />

        <Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

                  
    </>
  );

});

export default CustomizedDialogs;